/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) GPS Quality Icon component - the
 * only Alert indicator whose color varies (Warning "Poor" / Critical
 * "No GPS" per the Diagnostic Severity Color Rules), so unlike Engine
 * Light/EV System, it takes its color from `iconColor` rather than a
 * hardcoded value.
 */
export const GpsQualityIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_22062_16303)'>
        <path d='M8.62494 14.6967C11.896 14.6967 14.5477 12.0449 14.5477 8.77386C14.5477 5.5028 11.896 2.85107 8.62494 2.85107C5.35387 2.85107 2.70215 5.5028 2.70215 8.77386C2.70215 12.0449 5.35387 14.6967 8.62494 14.6967Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M8.62491 11.2596C9.99775 11.2596 11.1107 10.1467 11.1107 8.7739C11.1107 7.40106 9.99775 6.28815 8.62491 6.28815C7.25207 6.28815 6.13916 7.40106 6.13916 8.7739C6.13916 10.1467 7.25207 11.2596 8.62491 11.2596Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M8.625 2.47472V0.75' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M8.625 16.5V14.7753' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M2.47472 8.625H0.75' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M16.5001 8.625H14.7754' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      </g>
      <defs>
        <clipPath id='clip0_22062_16303'>
          <rect width='18' height='18' rx='4' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GpsQualityIcon;
